$(document).ready(() => {
    const PAGE_LENGTH = 10;

    $('.teamStatsBlock').each(setupTable);

    function setupTable() {
        const $teamStatsBlock = $(this);

        let displayStart = 0;
        let tournamentTypeFilter = $teamStatsBlock.data('tournament-type')
            ? '' + $teamStatsBlock.data('tournament-type')
            : 'all';
        let tournamentFilter = 'all';
        let tournamentTierFilter = 'all';
        let order = [[5, 'desc']];

        const currentUrl = TRNMNT_helpers.parseUrl();

        const $tournamentTypeFilter = $teamStatsBlock.find('.tournamentTypeFilter');
        const $tournamentFilter = $teamStatsBlock.find('.tournamentFilter');
        const $tournamentTierFilter = $teamStatsBlock.find('.tournamentTierFilter');

        const preserveFiltering = currentUrl.segments.indexOf('team') !== -1;

        if (preserveFiltering && currentUrl.params) {
            if (currentUrl.params.tds) {
                displayStart = currentUrl.params.tds;
            }
            if (currentUrl.params.toc && currentUrl.params.tod) {
                order = [[currentUrl.params.toc, currentUrl.params.tod]];
            }
            if (currentUrl.params.tttf) {
                $tournamentTypeFilter.val(currentUrl.params.tttf);
                tournamentTypeFilter = '' + currentUrl.params.tttf;
            }
            if (currentUrl.params.ttf) {
                $tournamentFilter.val(currentUrl.params.ttf);
                tournamentFilter = '' + currentUrl.params.ttf;
            }
            if (currentUrl.params.tttrf) {
                $tournamentTierFilter.val(currentUrl.params.tttrf);
                tournamentTierFilter = '' + currentUrl.params.tttrf;
            }
        }

        switchBestTeams();

        const $table = $teamStatsBlock.find('.teamStatsTable')
            // .on('processing.dt', function (e, settings, processing) {
            //     $('#teams_processing')
            //         .addClass('bg-dark')
            //         .css('display', processing ? 'block' : 'none')
            //         .html('Загружаются данные...');
            // })
            .DataTable({
                language: {
                    url: '/dataTables.ru.json'
                },
                scrollX: true,
                displayStart: displayStart,
                pageLength: PAGE_LENGTH,
                lengthChange: false,
                layout: {
                    bottomEnd: {
                        paging: {
                            firstLast: false,
                        },
                    },
                },
                info: false,
                // processing: true,
                serverSide: true,
                ajax: {
                    url: TEAMS_URL,
                    data: function (d) {
                        if (tournamentTypeFilter !== 'all') {
                            d.tournament_type = '' + tournamentTypeFilter;
                        }
                        if (tournamentFilter !== 'all') {
                            d.tournament_id = '' + tournamentFilter;
                        }
                        if (tournamentTypeFilter !== 'all') {
                            d.tier = '' + tournamentTierFilter;
                        }
                    },
                },
                order: order,
                search: {
                    return: true,
                },
                paging: !MAIN,
                searching: false,
                dataSrc: 'data',
                columns: [
                    //Порядковый
                    {
                        data: null,
                        className: "align-middle rounded-start text-end stats-data-platform",
                        orderable: false,
                        render: (data, type, full, meta) => {
                            const row = meta.row
                                + 1
                                + meta.settings._iDisplayLength
                                * Math.ceil(meta.settings._iDisplayStart / meta.settings._iDisplayLength);

                            return `<small class="text-muted">${row}</small>`;
                        },
                    },
                    //Аватар
                    {
                        data: null,
                        className: "align-middle stats-data-avatar",
                        orderable: false,
                        render: data => {
                            return `
                        <a href="${data.link}" class="fw-bold me-2 text-decoration-none"><img class="rounded-circle"
                             style="height: 50px; width: 50px;"
                             src="${data.avatar}"
                             alt="${data.title}}"
                        /></a>`;
                        },
                    },
                    //Платформа
                    {
                        data: null,
                        className: "align-middle stats-data-platform",
                        orderable: false,
                        render: data => {
                            return data.platform_id
                                ? `
                                    <i class="fa-brands fa-${data.platform_id}"
                                    style="color: ${TRNMNT_helpers.getPlatformColor(data.platform_id)}"
                                    ></i>`
                                : '';
                        },
                    },
                    //Название
                    {
                        data: null,
                        className: "align-middle title-row",
                        orderable: false,
                        render: data => {
                            const badge = data.country_id
                                ? `<span class="fi fi-${data.country_id} fis rounded-circle"></span>`
                                : `<a href="${data.link}" class="badge bg-secondary rounded-pill text-decoration-none" style="background: ${data.background} !important; color: ${data.color} !important; border: ${data.color} 1px solid">${data.short_title}</a>`;

                            return `<a href="${data.link}" class="fw-bold me-2 text-decoration-none">${data.title}</a> ${badge}`;
                        },
                    },
                    //Турниров
                    {
                        data: 'stats.tournaments',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Кубков
                    {
                        data: 'stats.cups',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //% побед
                    {
                        data: 'stats.wins_percent',
                        className: "align-middle text-center fw-bold stats-data",
                        render: data => data + '%',
                        orderSequence: ['desc', 'asc']
                    },
                    //Игры
                    {
                        data: 'stats.games',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Побед
                    {
                        data: 'stats.wins',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Поражения
                    {data: 'stats.loses', className: "align-middle text-center fw-bold stats-data"},
                    //Поражения в овертайме
                    {data: 'stats.lose_overtime', className: "align-middle text-center fw-bold stats-data"},
                    //Очки
                    {
                        data: 'stats.points',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Забито голов
                    {
                        data: 'stats.goals_for',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Пропущено голов
                    {data: 'stats.goals_against', className: "align-middle text-center fw-bold stats-data"},
                    //Большинство
                    {
                        data: 'stats.powerplay',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Меньшинство
                    {
                        data: 'stats.penalty_kill',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Удаления
                    {data: 'stats.penalty_total', className: "align-middle text-center fw-bold stats-data"},
                    //Броски
                    {
                        data: 'stats.shots',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //Силовые приёмы
                    {
                        data: 'stats.hits',
                        className: "align-middle text-center fw-bold stats-data",
                        orderSequence: ['desc', 'asc']
                    },
                    //L10
                    {
                        data: 'stats.last_10_games',
                        className: "align-middle rounded-end text-center fw-bold stats-data-l10",
                        orderSequence: ['desc', 'asc']
                    },
                ],
                createdRow(row) {
                    // $(row).addClass(tournamentTypeFilter === '3' ? 'bg-3x3' : 'bg-dark');
                    $(row).addClass('bg-dark');
                },
                initComplete: (settings, json) => {
                    $('div.dataTables_filter input').addClass('form-control-dark');
                }
            });

        if (preserveFiltering) {
            $table.on('page.dt', function () {
                const info = $table.page.info();
                const displayStart = info.page * PAGE_LENGTH;
                TRNMNT_helpers.insertURLQueryParam('tds', displayStart);

                $([document.documentElement, document.body]).animate({
                    scrollTop: $teamStatsBlock.find('.teamStatsTable').offset().top - 160
                }, 0);
            });

            $table.on('order.dt', function () {
                // This will show: "Ordering on column 1 (asc)", for example
                const order = $table.order();
                TRNMNT_helpers.insertURLQueryParam('toc', order[0][0]);
                TRNMNT_helpers.insertURLQueryParam('tod', order[0][1]);
                TRNMNT_helpers.insertURLQueryParam('tds', 0);
            });
        }

        // $table.on( 'column-sizing.dt', function () {
        //     const $columns = $table.columns()
        //         .nodes()
        //         .flatten()  // Reduce to a 1D array
        //         .to$()
        //         .css({'padding-right': '26px'});
        // });

        $tournamentTypeFilter.on('change', event => {
            event.preventDefault();
            tournamentTypeFilter = '' + $(event.target).val();

            switchBestTeams();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tttf', tournamentTypeFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('toc', order[0][0]);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tod', order[0][1]);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tds', 0);

            $table.draw();
        });

        $tournamentFilter.on('change', event => {
            event.preventDefault();
            tournamentFilter = '' + $(event.target).val();

            switchBestTeams();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('ttf', tournamentFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('toc', order[0][0]);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tod', order[0][1]);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tds', 0);

            $table.draw();
        });

        $tournamentTierFilter.on('change', event => {
            event.preventDefault();
            tournamentTierFilter = '' + $(event.target).val();

            switchBestTeams();

            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tttrf', tournamentTierFilter);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('toc', order[0][0]);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tod', order[0][1]);
            preserveFiltering && TRNMNT_helpers.insertURLQueryParam('tds', 0);

            $table.draw();
        });

        function switchBestTeams() {
            $('.bestTeams').hide();
            let ttfClass = 'six';
            switch (tournamentTypeFilter) {
                case '3':
                    ttfClass = 'three';
                    break;
                case 'all':
                    ttfClass = 'all';
                    break;
            }
            const $block = $(`.bestTeams.${ttfClass}`);
            $block.show();
        }
    }
});
